<template>
<div class="nav">
    <div class="mainWidth">
        <el-menu :default-active="activeMenu" class="el-menu-nav" mode="horizontal" router>
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/liveBroadcast">正在直播</el-menu-item>
            <el-menu-item index="/liveNotice">直播预告</el-menu-item>
            <el-menu-item index="/liveReview"  v-if="allowLiveReview">直播回顾</el-menu-item>
        </el-menu>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    computed: {
        activeMenu() {
            const { meta, path } = this.$route
            if (meta.activeMenu) {
                return meta.activeMenu
            }
            return path
        },
        allowLiveReview(){
            return this.$store.getters.allowLiveReview
        },
    },

}
</script>

<style lang="scss" scoped>
.nav {
    height: 48px;
    background: #3943d9;
}

.el-menu-nav,
.el-menu--horizontal {
    background: #3943d9;
    border-bottom: 0;

    .el-menu-item {
        width: 204px;
        height: 48px;
        line-height: 48px;
        border-bottom: 0;
        color: #fff;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
    }

    .el-menu-item+.el-menu-item {
        margin-left: 120px;
    }

    .el-menu-item.is-active {
        border-bottom: 0;
        background-color: #6790ff;
        color: #fff;
    }

    // .el-menu-item:not(.is-disabled):focus {
    //     color: #fff;
    //     background-color: #3943d9;
    // }

    .el-menu-item:not(.is-disabled):focus,
    .el-menu-item:not(.is-disabled):hover {
        color: #fff;
    }

    .el-menu-item:not(.is-disabled):focus,
    .el-menu-item:not(.is-disabled):hover,
    .el-submenu .el-submenu__title:hover {
        background-color: #6790ff;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/TheNav.vue